var _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileviewlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 702,
    height: 650,
    viewBox: "0 0 702 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M537.837 537.837C481.384 594.277 404.828 625.989 325 626C159.871 626 24 490.129 24 325C24 159.871 159.871 24 325 24C490.129 24 626 159.871 626 325",
    stroke: "#0066FF",
    strokeWidth: 47.8046,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M563.12 259.832H688.848C691.035 259.824 693.186 260.398 695.079 261.495C696.972 262.592 698.539 264.172 699.621 266.074C700.702 267.976 701.258 270.131 701.232 272.319C701.206 274.507 700.599 276.648 699.473 278.524L636.594 384.145C635.503 385.992 633.949 387.523 632.086 388.586C630.222 389.649 628.114 390.209 625.969 390.209C623.823 390.209 621.715 389.649 619.852 388.586C617.989 387.523 616.435 385.992 615.343 384.145L552.465 278.524C551.357 276.643 550.766 274.502 550.751 272.319C550.736 270.136 551.297 267.988 552.378 266.091C553.459 264.195 555.022 262.617 556.908 261.518C558.794 260.419 560.937 259.837 563.12 259.832Z",
    fill: "#0066FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 619.543,
    cy: 423.18,
    r: 16.794,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 560.115,
    cy: 511.026,
    r: 16.794,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 593.705,
    cy: 469.686,
    r: 16.794,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.79 101.511C254.601 101.511 200.713 124.921 160.981 166.591C121.249 208.261 98.9275 264.778 98.9275 323.709C98.9275 382.639 121.249 439.156 160.981 480.826C200.713 522.496 254.601 545.906 310.79 545.906L310.79 494.674C267.556 494.674 226.093 476.662 195.522 444.6C164.951 412.537 147.777 369.052 147.777 323.709C147.777 278.366 164.951 234.88 195.522 202.818C226.093 170.756 267.556 152.743 310.79 152.743L310.79 101.511Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328.873 101.511C387.803 101.511 444.32 124.921 485.99 166.591C527.66 208.261 551.07 264.778 551.07 323.709C551.07 382.639 527.66 439.156 485.99 480.826C444.32 522.496 387.803 545.906 328.873 545.906L328.873 323.709L328.873 101.511Z",
    fill: "#0066FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 377.964,
    y: 331.535,
    width: 26.1409,
    height: 91.4931,
    rx: 13.0704,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 420.444,
    y: 298.859,
    width: 26.1409,
    height: 124.169,
    rx: 13.0704,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 462.921,
    y: 269.451,
    width: 26.1409,
    height: 153.578,
    rx: 13.0704,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileviewlogo);
export default __webpack_public_path__ + "static/media/mobile view logo.4cbba3210f2220f5b2b4deff4d098427.svg";
export { ForwardRef as ReactComponent };